import React, { useContext } from "react";
import logo from "../static/images/logo256.png";
import { AuthContext } from "../App";
import { Navbar, Nav, NavDropdown, Container } from 'react-bootstrap';
import { Link } from "react-router-dom";

import "../style/Nav.css";


const CFINavbar = () => {
    const { state: authState, dispatch: authDispatch } = useContext(AuthContext);

    function logoutClick() {
        authDispatch({
            type: "LOGOUT",
            payload: {},
        });
    }

    return (
        <Navbar className="mt-auto" expand="lg">
            <Container>
                <Nav className="py-3 px-5">
                    <Nav.Item>
                        <Nav.Link href="/">
                            <img
                                src={logo}
                                width="130"
                                height="130"
                                className="d-inline-block align-top"
                                alt="logo"
                                loading="lazy"
                            ></img>
                        </Nav.Link>
                    </Nav.Item>
                    </Nav>

        {/* Toggle button for mobile view */}
        <Navbar.Toggle aria-controls="basic-navbar-nav" />

        {/* Navigation items */}
        <Navbar.Collapse id="basic-navbar-nav">

                    <Nav className="mx-auto my-auto" activeKey="/">
                        <Nav.Item className="mx-3">
                            <Nav.Link eventKey="nav-home" className="nav-links" href="/">
                                HOME
                            </Nav.Link>
                        </Nav.Item>
                        <Nav.Item className="mx-3">
                            <Nav.Link eventKey="nav-demo" className="nav-links" href="/about">
                                ABOUT US
                            </Nav.Link>
                        </Nav.Item>

                        {/* Dropdown link */}
                        <NavDropdown title="PRODUCTS" id="products-nav-dropdown" 
                        bsPrefix="nav-link" className="mx-3">
                            <NavDropdown.Item href="/STCH" className="nav-link">
                                STCH
                            </NavDropdown.Item>
                        {/* <NavDropdown.Divider /> */}
                        </NavDropdown>
                    </Nav>

                    <Nav>
                        {!authState.isAuthenticated ? (
                            <Nav.Item>
                                <Nav.Link eventKey="nav-login" href="/login" className="nav-links">
                                    CLIENT LOGIN
                                </Nav.Link>
                            </Nav.Item>
                        ) : (
                            <>
                                <Nav.Item className="mx-5">
                                    <Nav.Link onClick={logoutClick} href="/" className="nav-links">
                                        LOGOUT
                                    </Nav.Link>
                                </Nav.Item>
                                {authState.user.isAdmin ? (
                                    <Nav.Item>
                                        {/* For some reason Nav.Link
                                        does not work here for the routes */}
                                        <Link className="internal-link" to="/admin_management">
                                            Admin-Management
                                        </Link>
                                    </Nav.Item>
                                ) : 
                                authState.user.isSupervisor ? (
                                    <Nav.Item>
                                        <Link className="internal-link" to="/supervisor">
                                            {authState.user.name}
                                        </Link>
                                    </Nav.Item>
                                ) : (
                                    <Nav.Item>
                                        <Link className="internal-link" to="/results">
                                            {authState.user.name}
                                        </Link>
                                    </Nav.Item>
                                )}
                            </>
                        )}

                        {/* <Form className="d-flex">
                            <Button variant="danger">GET IN TOUCH</Button>
                        </Form> */}

                    </Nav>
        </Navbar.Collapse>
            </Container>
        </Navbar>
    );
};

export default CFINavbar;
